module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isUserLogged) ? _c('div', {
    staticClass: "footer-menu-div"
  }) : _vm._e(), _vm._v(" "), (_vm.isUserLogged && _vm.accountTypeIsPro) ? _c('div', {
    staticClass: "footer-menu-div"
  }, [_c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_WHAT_IS_BRASTER_PRO')
    }
  }, [_vm._v(_vm._s(_vm.$t('WHAT_IS_BRASTER_PRO')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_HOW_DOES_BRASTER_PRO_WORK')
    }
  }, [_vm._v(_vm._s(_vm.$t('HOW_DOES_BRASTER_PRO_WORK')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_SKUTECZNOSC_PRO')
    }
  }, [_vm._v(_vm._s(_vm.$t('EFFICIENCY')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_CLINICAL_EXAMINATIONS')
    }
  }, [_vm._v(_vm._s(_vm.$t('CLINICAL_EXAMINATIONS')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_FIRMA_PRO')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABOUT_COMPANY')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_CONTACT')
    }
  }, [_vm._v(_vm._s(_vm.$t('CONTACT')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.$t('LINK_RELACJE_INWESTORSKIE')
    }
  }, [_vm._v(_vm._s(_vm.$t('RELACJE_INWESTORSKIE')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TERMS')
    }
  }, [_vm._v(_vm._s(_vm.$t('TERMS_AND_PRIVACY_POLICY')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isUserLogged && !_vm.accountTypeIsPro) ? _c('div', {
    staticClass: "footer-menu-div"
  }, [_c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_CZYM_JEST_BRASTER')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABOUT_BRASTER')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_JAK_DZIALA_BRASTER')
    }
  }, [_vm._v(_vm._s(_vm.$t('HOW_IT_WORKS')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_SKUTECZNOSC')
    }
  }, [_vm._v(_vm._s(_vm.$t('EFFICIENCY')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_PROFILAKTYKA')
    }
  }, [_vm._v(_vm._s(_vm.$t('PREVENTION')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_FIRMA')
    }
  }, [_vm._v(_vm._s(_vm.$t('ABOUT_COMPANY')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.userShopUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('BUY_ONLINE')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_CONTACT')
    }
  }, [_vm._v(_vm._s(_vm.$t('CONTACT')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TO_FAQ')
    }
  }, [_vm._v(_vm._s(_vm.$t('FAQ')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.$t('LINK_RELACJE_INWESTORSKIE')
    }
  }, [_vm._v(_vm._s(_vm.$t('RELACJE_INWESTORSKIE')))])]), _vm._v(" "), _c('li', {
    staticClass: "footer-menu__item"
  }, [_c('a', {
    staticClass: "footer-menu__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TERMS')
    }
  }, [_vm._v(_vm._s(_vm.$t('TERMS_AND_PRIVACY_POLICY')))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72617c17","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/footer/footer-menu.vue
// module id = 1219
// module chunks = 0